const locales = 'de-DE' // use state from store if multilingual is supported
const currency = 'EUR' // use state from store if multilingual is supported

const stringMoneyFormatterWithSymbol = new Intl.NumberFormat(locales, {
  style: 'currency',
  currency,
})

const stringMoneyFormatter = new Intl.NumberFormat(locales, {
  currency,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const getLocalesMoneyStrValue = (val: number, showCurrencySymbol?: boolean | undefined) =>
  (showCurrencySymbol ? stringMoneyFormatterWithSymbol : stringMoneyFormatter).format(val)

export const getLocalesDateStr = (val: Date) =>
  val?.toLocaleDateString(locales, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
